import React from "react";
import { Layout } from "../components/layout";
import { User, Bell, Shield, Database, Key, Bug } from "lucide-react";
import { DebugPanel } from "../components/debug";
import { useAuth } from "../contexts/AuthContext";

export function SettingsPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-white mb-8">Settings</h1>

        <div className="space-y-6">
          {/* Profile Settings */}
          <div className="bg-gray-800/50 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <User className="h-5 w-5 text-blue-400" />
              <h2 className="text-xl font-semibold text-white">
                Profile Settings
              </h2>
            </div>
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Display Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-300 mb-2"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
                  placeholder="your@email.com"
                />
              </div>
            </div>
          </div>

          {/* Notification Settings */}
          <div className="bg-gray-800/50 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <Bell className="h-5 w-5 text-purple-400" />
              <h2 className="text-xl font-semibold text-white">
                Notification Settings
              </h2>
            </div>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-white">
                    Email Notifications
                  </h3>
                  <p className="text-sm text-gray-400">
                    Receive updates about your patterns
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
            </div>
          </div>

          {/* Security Settings */}
          <div className="bg-gray-800/50 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <Shield className="h-5 w-5 text-green-400" />
              <h2 className="text-xl font-semibold text-white">Security</h2>
            </div>
            <div className="space-y-4">
              <button className="text-blue-400 hover:text-blue-300 transition-colors text-sm">
                Change Password
              </button>
              <button className="text-blue-400 hover:text-blue-300 transition-colors text-sm ml-4">
                Enable Two-Factor Authentication
              </button>
            </div>
          </div>

          {/* API Settings */}
          <div className="bg-gray-800/50 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <Key className="h-5 w-5 text-yellow-400" />
              <h2 className="text-xl font-semibold text-white">API Keys</h2>
            </div>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-white">
                    Production API Key
                  </h3>
                  <p className="text-sm text-gray-400">••••••••••••••••</p>
                </div>
                <button className="text-blue-400 hover:text-blue-300 transition-colors text-sm">
                  Regenerate
                </button>
              </div>
            </div>
          </div>

          {/* Debug Panel */}
          <div className="bg-gray-800/50 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <Bug className="h-5 w-5 text-red-400" />
              <h2 className="text-xl font-semibold text-white">Debug Tools</h2>
            </div>
            <DebugPanel />
          </div>

          {/* Save Button */}
          <div className="flex justify-end">
            <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
